import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'

export const defaultText = {
  question: 'Write your question here...',
  helpText: 'Choose as many options as you want',
}

export const defaultSettings = {
  type: BLOCK_TYPES.FIELD,
  fieldType: FIELD_TYPES.MULTIPLE_CHOICE,
  question: defaultText.question,
  isRequired: false,
  hasHelpText: false,
  helpText: defaultText.helpText,
}
